import { getLoginPageUrl } from './commonHelper';
const CookieHelper = {
  getCookie(key) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf(key + '=') === 0) {
        return cookie.substring(key.length + 1, cookie.length);
      }
    }
    return null;
  },
  /**
   * @description Function to to create a cookie
   * @param {String} name Cookie name
   * @param {String} value Cookie value
   * @param {Object} config Configuration like [days, path, domain]
  */
  setCookie(name, value, config) {
    if (name && name.length > 0 && value !== undefined) {
      const configObj = config || {};
      const {
        days,
        time,
        path,
        domain
      } = configObj;
      let cookie = "".concat(name, "=").concat(encodeURIComponent(value));
      if (path) {
        cookie += "; path=".concat(path);
      } else {
        cookie += '; path=/';
      }
      if (domain) {
        cookie += "; domain=".concat(domain);
      }
      if (days) {
        const now = new Date();
        now.setTime(now.getTime() + days * 24 * 60 * 60 * 1000);
        cookie += "; expires=".concat(now.toUTCString());
      } else if (time) {
        const now = new Date(time);
        cookie += "; expires=".concat(now.toUTCString());
      }
      try {
        document.cookie = "".concat(cookie, ";Secure;SameSite=Strict");
        return true;
      } catch (error) {
        return false;
      }
    }
    return false;
  },
  eraseCookie(key) {
    document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  },
  /**
   * @description Function to clear all cookies stored.
  */
  clearAllCookies() {
    document.cookie.split(';').forEach(value => {
      document.cookie = "".concat(value.split('=')[0], " =;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/");
    });
    const {
      pathname,
      search
    } = window.location;
    const callbackUrl = "?url=".concat(pathname).concat(search);
    const loginPageUrl = getLoginPageUrl();
    if (pathname !== loginPageUrl) {
      window.location.href = "".concat(loginPageUrl).concat(callbackUrl);
    }
  }
};
export default CookieHelper;